import { render, staticRenderFns } from "./CardProductOrderInfo.vue?vue&type=template&id=57600d90&scoped=true&"
import script from "./CardProductOrderInfo.vue?vue&type=script&lang=js&"
export * from "./CardProductOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./CardProductOrderInfo.vue?vue&type=style&index=0&id=57600d90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57600d90",
  null
  
)

export default component.exports